import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ActionItemCategory = Loadable(
  lazy(() =>
    import("./ActionItemCategory").then(({ ActionItemCategory }) => ({
      default: ActionItemCategory,
    })),
  ),
);

const ManageActionItemCategory = Loadable(
  lazy(() =>
    import("./ManageActionItemCategory").then(({ ManageActionItemCategory }) => ({
      default: ManageActionItemCategory,
    })),
  ),
);

export const ActionItemCategoryRoutes = [
  {
    path: "/action-item-category",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM_CATEGORY]}>
        <ActionItemCategory />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/action-item-category/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM_CATEGORY]}>
        <ManageActionItemCategory />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/action-item-category/manage/:categoryId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM_CATEGORY]}>
        <ManageActionItemCategory />
      </AuthorizedRoute>
    ),
  },
];
